export const ROLE_CHANGED = 'ROLE_CHANGED';
export const ACTIVE_PATIENT='ACTIVE_PATIENT';
export const SET_ACTIVE_PATIENT_NAME='SET_ACTIVE_PATIENT_NAME';
export const ACTIVE_PRACTITIONER='ACTIVE_PRACTITIONER';

